module.exports = __webpack_public_path__ + "img/icon_counter_plus.e3171584.svg";